var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBattery = function SvgBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.765 5.753c1.37 0 2.482 1.111 2.482 2.482v7.529a2.483 2.483 0 0 1-2.482 2.482H4.47a2.48 2.48 0 0 1-2.482-2.482v-7.53c0-1.37 1.111-2.48 2.482-2.48zM4.47 6.953c-.708 0-1.282.574-1.283 1.282v7.529c0 .708.575 1.282 1.283 1.282h11.294c.708 0 1.282-.574 1.282-1.282v-7.53c0-.707-.574-1.281-1.282-1.281zm16.94 2.564a.6.6 0 0 1 .6.6v3.764a.6.6 0 1 1-1.2 0v-3.764a.6.6 0 0 1 .6-.6"
  })));
};
export default SvgBattery;